module.exports = __webpack_public_path__ + "img/photo-0100.ac3649f3.jpg";